// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AutoCompleteOption-module__font-s-10___syhXz {
  font-size: 10px !important;
}

.AutoCompleteOption-module__font-s-12___KdJvm {
  font-size: 12px !important;
}

.AutoCompleteOption-module__font-s-13___QK_0r {
  font-size: 13px !important;
}

.AutoCompleteOption-module__font-s-14___IR2qi {
  font-size: 14px !important;
}

.AutoCompleteOption-module__font-s-15___BzKi4 {
  font-size: 15px !important;
}

.AutoCompleteOption-module__font-s-16___qrL0N {
  font-size: 16px !important;
}

.AutoCompleteOption-module__font-s-18___Upwvf {
  font-size: 18px !important;
}

.AutoCompleteOption-module__font-s-20___z7O3Z {
  font-size: 20px !important;
}

.AutoCompleteOption-module__font-s-22___Q1LoV {
  font-size: 22px !important;
}

.AutoCompleteOption-module__font-s-28___Eda5n {
  font-size: 28px !important;
}

.AutoCompleteOption-module__font-w-400___wZS2H {
  font-weight: 400 !important;
}

.AutoCompleteOption-module__font-w-500___ril8k {
  font-weight: 500 !important;
}

.AutoCompleteOption-module__font-w-600___q_1mP {
  font-weight: 600 !important;
}

.AutoCompleteOption-module__font-w-700____0SEJ {
  font-weight: 700 !important;
}

.AutoCompleteOption-module__p-5___sOso3 {
  padding: 5px !important;
}

.AutoCompleteOption-module__p-12___lAWfM {
  padding: 12px !important;
}

.AutoCompleteOption-module__p-16___SZTRk {
  padding: 16px !important;
}

.AutoCompleteOption-module__p-30___YL7V1 {
  padding: 30px !important;
}

.AutoCompleteOption-module__p-b-0___XX6yo {
  padding-bottom: 0 !important;
}

.AutoCompleteOption-module__p-b-5___P8VpM {
  padding-bottom: 5px !important;
}

.AutoCompleteOption-module__p-b-10___AkD0u {
  padding-bottom: 10px !important;
}

.AutoCompleteOption-module__p-b-12___zZ4_3 {
  padding-bottom: 12px !important;
}

.AutoCompleteOption-module__p-b-16___IFV5G {
  padding-bottom: 16px !important;
}

.AutoCompleteOption-module__p-b-18___csUjQ {
  padding-bottom: 18px !important;
}

.AutoCompleteOption-module__p-b-20___LAfWC {
  padding-bottom: 20px !important;
}

.AutoCompleteOption-module__p-b-25___ktu1I {
  padding-bottom: 25px !important;
}

.AutoCompleteOption-module__p-b-30___aHDz7 {
  padding-bottom: 30px !important;
}

.AutoCompleteOption-module__p-b-50___l5ixM {
  padding-bottom: 50px !important;
}

.AutoCompleteOption-module__p-t-0___uOkhl {
  padding-top: 0 !important;
}

.AutoCompleteOption-module__p-t-12___VP8Qr {
  padding-top: 12px !important;
}

.AutoCompleteOption-module__p-t-16___wzMDE {
  padding-top: 16px !important;
}

.AutoCompleteOption-module__p-t-18___iYWp8 {
  padding-top: 18px !important;
}

.AutoCompleteOption-module__p-t-20___W8vUh {
  padding-top: 20px !important;
}

.AutoCompleteOption-module__p-t-30___FV3bT {
  padding-top: 30px !important;
}

.AutoCompleteOption-module__p-t-40___haaUR {
  padding-top: 40px !important;
}

.AutoCompleteOption-module__p-t-50___A5LlW {
  padding-top: 50px !important;
}

.AutoCompleteOption-module__p-l-20___CRART {
  padding-left: 20px !important;
}

.AutoCompleteOption-module__p-l-30___d4ODy {
  padding-left: 30px !important;
}

.AutoCompleteOption-module__p-l-40___NDuEC {
  padding-left: 40px !important;
}

.AutoCompleteOption-module__p-r-16___ye03R {
  padding-right: 16px !important;
}

.AutoCompleteOption-module__p-r-20___X26b4 {
  padding-right: 20px !important;
}

.AutoCompleteOption-module__p-r-30___sB8CQ {
  padding-right: 30px !important;
}

.AutoCompleteOption-module__p-r-50___oqWHZ {
  padding-right: 50px !important;
}

.AutoCompleteOption-module__p-r-60___eAR_S {
  padding-right: 60px !important;
}

.AutoCompleteOption-module__m-b-1___VIxoa {
  margin-bottom: 1px !important;
}

.AutoCompleteOption-module__m-b-2___IFspY {
  margin-bottom: 2px !important;
}

.AutoCompleteOption-module__m-b-6___dT4lG {
  margin-bottom: 6px !important;
}

.AutoCompleteOption-module__m-b-8___QAV0o {
  margin-bottom: 8px !important;
}

.AutoCompleteOption-module__m-b-10___FB1HR {
  margin-bottom: 10px !important;
}

.AutoCompleteOption-module__m-b-14___pxuNh {
  margin-bottom: 14px !important;
}

.AutoCompleteOption-module__m-b-16___SN4aJ {
  margin-bottom: 16px !important;
}

.AutoCompleteOption-module__m-b-20___HYHwd {
  margin-bottom: 20px !important;
}

.AutoCompleteOption-module__m-b-22___I6Z9t {
  margin-bottom: 22px !important;
}

.AutoCompleteOption-module__m-b-24___qA2H9 {
  margin-bottom: 24px !important;
}

.AutoCompleteOption-module__m-b-30___qRDjJ {
  margin-bottom: 30px !important;
}

.AutoCompleteOption-module__m-b-32___QzSm7 {
  margin-bottom: 32px !important;
}

.AutoCompleteOption-module__m-b-40___m1gs3 {
  margin-bottom: 40px !important;
}

.AutoCompleteOption-module__m-t-2___tICZY {
  margin-top: 2px !important;
}

.AutoCompleteOption-module__m-t-3___LhHwb {
  margin-top: 3px !important;
}

.AutoCompleteOption-module__m-t-4___M1SEi {
  margin-top: 4px !important;
}

.AutoCompleteOption-module__m-t-5___YzWVQ {
  margin-top: 5px !important;
}

.AutoCompleteOption-module__m-t-8___rNTwQ {
  margin-top: 8px !important;
}

.AutoCompleteOption-module__m-t-10___Vhnfa {
  margin-top: 10px !important;
}

.AutoCompleteOption-module__m-t-15___Ic5MG {
  margin-top: 15px !important;
}

.AutoCompleteOption-module__m-t-16___L9Mda {
  margin-top: 16px !important;
}

.AutoCompleteOption-module__m-t-20___V4RC1 {
  margin-top: 20px !important;
}

.AutoCompleteOption-module__m-t-22___mcLcq {
  margin-top: 22px !important;
}

.AutoCompleteOption-module__m-t-30____OK59 {
  margin-top: 30px !important;
}

.AutoCompleteOption-module__m-t-32___aX9Re {
  margin-top: 32px !important;
}

.AutoCompleteOption-module__m-l-auto___YF39L {
  margin-left: auto !important;
}

.AutoCompleteOption-module__m-l-4___r684F {
  margin-left: 4px !important;
}

.AutoCompleteOption-module__m-l-5___mtxcq {
  margin-left: 5px !important;
}

.AutoCompleteOption-module__m-l-6___TP9jG {
  margin-left: 6px !important;
}

.AutoCompleteOption-module__m-l-8___ns6vh {
  margin-left: 8px !important;
}

.AutoCompleteOption-module__m-l-10___OZ0hf {
  margin-left: 10px !important;
}

.AutoCompleteOption-module__m-l-16___nPSBK {
  margin-left: 16px !important;
}

.AutoCompleteOption-module__m-l-20___iKGls {
  margin-left: 20px !important;
}

.AutoCompleteOption-module__m-l-24___PW7bv {
  margin-left: 24px !important;
}

.AutoCompleteOption-module__m-l-30___tSiMF {
  margin-left: 30px !important;
}

.AutoCompleteOption-module__m-l-35___nrDGn {
  margin-left: 35px !important;
}

.AutoCompleteOption-module__m-l-40___llfGT {
  margin-left: 40px !important;
}

.AutoCompleteOption-module__m-r-8___J5odo {
  margin-right: 8px !important;
}

.AutoCompleteOption-module__m-r-10____IK49 {
  margin-right: 10px !important;
}

.AutoCompleteOption-module__m-r-16___DIVnt {
  margin-right: 16px !important;
}

.AutoCompleteOption-module__m-r-20___lM8Sz {
  margin-right: 20px !important;
}

.AutoCompleteOption-module__m-r-24___JI7eo {
  margin-right: 24px !important;
}

.AutoCompleteOption-module__m-r-30___gPCJ9 {
  margin-right: 30px !important;
}

.AutoCompleteOption-module__m-r-40___elQhU {
  margin-right: 40px !important;
}

.AutoCompleteOption-module__border-r-3___g1G_w {
  border-radius: 3px !important;
}

.AutoCompleteOption-module__border-r-4___jAdnT {
  border-radius: 4px !important;
}

.AutoCompleteOption-module__border-r-6___VuNoF {
  border-radius: 6px !important;
}

.AutoCompleteOption-module__border-r-10___WcRzG {
  border-radius: 10px !important;
}

.AutoCompleteOption-module__border-r-12___ihyLb {
  border-radius: 12px !important;
}

.AutoCompleteOption-module__border-r-16___O8BfV {
  border-radius: 16px !important;
}

.AutoCompleteOption-module__border-r-50___HAKY8 {
  border-radius: 50% !important;
}

.AutoCompleteOption-module__primary-border___dEUxj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AutoCompleteOption-module__primary-border-b___sR7VI {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AutoCompleteOption-module__primary-border-t___oNXlD {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AutoCompleteOption-module__primary-border-l___N5Mra {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AutoCompleteOption-module__primary-border-r___QHMXV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AutoCompleteOption-module__secondary-border___T86id {
  border: 1px solid #637768;
}

.AutoCompleteOption-module__secondary-border-b___UtAzR {
  border-bottom: 1px solid #637768;
}

.AutoCompleteOption-module__secondary-border-t___vh9jF {
  border-top: 1px solid #637768;
}

.AutoCompleteOption-module__secondary-border-l___rAThQ {
  border-left: 1px solid #637768;
}

.AutoCompleteOption-module__secondary-border-r___wZOMo {
  border-right: 1px solid #637768;
}

.AutoCompleteOption-module__gap-0___qgHE4 {
  gap: 0 !important;
}

.AutoCompleteOption-module__gap-2___pds6f {
  gap: 2px !important;
}

.AutoCompleteOption-module__gap-4___nQrY3 {
  gap: 4px !important;
}

.AutoCompleteOption-module__gap-5___ZVImR {
  gap: 5px !important;
}

.AutoCompleteOption-module__gap-6___hCzuL {
  gap: 6px !important;
}

.AutoCompleteOption-module__gap-8___jLpD1 {
  gap: 8px !important;
}

.AutoCompleteOption-module__gap-10___as_Qg {
  gap: 10px !important;
}

.AutoCompleteOption-module__gap-12___nnNbr {
  gap: 12px !important;
}

.AutoCompleteOption-module__gap-14___ucwWC {
  gap: 14px !important;
}

.AutoCompleteOption-module__gap-16___qSflx {
  gap: 16px !important;
}

.AutoCompleteOption-module__gap-18___SILU2 {
  gap: 18px !important;
}

.AutoCompleteOption-module__gap-20___uOU63 {
  gap: 20px !important;
}

.AutoCompleteOption-module__gap-24___Hcs9I {
  gap: 24px !important;
}

.AutoCompleteOption-module__gap-26___kzPtQ {
  gap: 26px !important;
}

.AutoCompleteOption-module__gap-30___dwsNT {
  gap: 30px !important;
}

.AutoCompleteOption-module__gap-32___GJyro {
  gap: 32px !important;
}

.AutoCompleteOption-module__gap-40___h09Db {
  gap: 40px !important;
}

.AutoCompleteOption-module__gap-50___J0ayA {
  gap: 50px !important;
}

.AutoCompleteOption-module__flex-1___VnIM9 {
  flex: 1;
}

.AutoCompleteOption-module__flex-none___bHJBw {
  flex: none !important;
}

.AutoCompleteOption-module__flex-column___JGMTW {
  display: flex;
  flex-direction: column !important;
}

.AutoCompleteOption-module__flex-row___aRIP6 {
  display: flex;
  flex-direction: row !important;
}

.AutoCompleteOption-module__vertically-centered___b0qti {
  display: flex;
  align-items: center !important;
}

.AutoCompleteOption-module__horizontally-centered___pXlqM {
  display: flex;
  justify-content: center !important;
}

.AutoCompleteOption-module__horizontally-end___WNW_i {
  display: flex;
  justify-content: end !important;
}

.AutoCompleteOption-module__vertically-start___DWjya {
  display: flex;
  align-items: start !important;
}

.AutoCompleteOption-module__space-between___Wht9k {
  display: flex;
  justify-content: space-between !important;
}

.AutoCompleteOption-module__flex-wrap___foSL6 {
  flex-wrap: wrap !important;
}

.AutoCompleteOption-module__height-100___t18Ip {
  height: 100%;
}

.AutoCompleteOption-module__width-50___e5VnW {
  width: 50% !important;
}

.AutoCompleteOption-module__width-100___MlRoM {
  width: 100%;
}

.AutoCompleteOption-module__cursor-pointer___iiBzd {
  cursor: pointer;
}

.AutoCompleteOption-module__cursor-not-allowed___jFclO {
  cursor: not-allowed !important;
}

.AutoCompleteOption-module__absolute-centered___plCzM {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AutoCompleteOption-module__absolute___gF_tU {
  position: absolute;
}

.AutoCompleteOption-module__relative___qN0H5 {
  position: relative;
}

.AutoCompleteOption-module__fixed___ENxEW {
  position: fixed;
}

.AutoCompleteOption-module__visible___AtoeT {
  opacity: 1;
}

.AutoCompleteOption-module__invisible___Q_1Vx {
  opacity: 0;
}

.AutoCompleteOption-module__col-90___sQopt {
  width: 90% !important;
}

.AutoCompleteOption-module__col-auto___mf3Gz {
  width: auto !important;
}

.AutoCompleteOption-module__medical-tabs___zFd38 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AutoCompleteOption-module__medical-table-new___H1B4H {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AutoCompleteOption-module__medical-table-new___H1B4H:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AutoCompleteOption-module__medical-table-new___H1B4H::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AutoCompleteOption-module__medical-table-new___H1B4H::-webkit-scrollbar-track {
  display: none;
}
.AutoCompleteOption-module__medical-table-new___H1B4H.AutoCompleteOption-module__no-pagination___cc_TA {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AutoCompleteOption-module__medical-table-new___H1B4H.AutoCompleteOption-module__no-pagination___cc_TA:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AutoCompleteOption-module__medical-table-new___H1B4H.AutoCompleteOption-module__no-pagination___cc_TA::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AutoCompleteOption-module__medical-table-new___H1B4H.AutoCompleteOption-module__no-pagination___cc_TA::-webkit-scrollbar-track {
  display: none;
}

.AutoCompleteOption-module__medical-table-empty___dHQU8 {
  padding: 14px 40px !important;
}

.AutoCompleteOption-module__icon-btn___tRxAx {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AutoCompleteOption-module__search-icon___AOOBK {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AutoCompleteOption-module__disable-select___vmaGw {
  user-select: none;
}

.AutoCompleteOption-module__break-word___TjarC {
  word-break: break-word;
}

.AutoCompleteOption-module__popup-clear-btn___rrd_8 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AutoCompleteOption-module__scroll-m-b-20___sU9sX {
  scroll-margin-bottom: 20px;
}

.AutoCompleteOption-module__name___CdDAD {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-family);
  font-weight: 400;
  margin-right: 1em;
  max-width: 45%;
  color: #375844;
}

.AutoCompleteOption-module__info___S03W8 {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 0.8rem;
  color: #859989;
}
.AutoCompleteOption-module__info___S03W8 span {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainNavigation/components/AutoCompleteOption/AutoCompleteOption.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECEE,gBAAA;EACA,mBAAA;EACA,uBAAA;ECoBA,+BApBO;EAqBP,gBAFmD;EFpBnD,iBAAA;EACA,cAAA;EACA,cAAA;AAiqBF;;AA9pBA;EEgBE,+BApBO;EAqBP,gBAFmD;EAGnD,iBAAA;EFhBA,cAAA;AAmqBF;AAjqBE;EACE,iBAAA;AAmqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.name {\n  @include clipped-text;\n  @include get-font();\n  margin-right: 1em;\n  max-width: 45%;\n  color: get-color(greenNew, dark);\n}\n\n.info {\n  @include get-font($font-size: x-small);\n  color: get-color(greenNew, medium);\n\n  span {\n    margin-right: 5px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AutoCompleteOption-module__font-s-10___syhXz`,
	"fontS12": `AutoCompleteOption-module__font-s-12___KdJvm`,
	"fontS13": `AutoCompleteOption-module__font-s-13___QK_0r`,
	"fontS14": `AutoCompleteOption-module__font-s-14___IR2qi`,
	"fontS15": `AutoCompleteOption-module__font-s-15___BzKi4`,
	"fontS16": `AutoCompleteOption-module__font-s-16___qrL0N`,
	"fontS18": `AutoCompleteOption-module__font-s-18___Upwvf`,
	"fontS20": `AutoCompleteOption-module__font-s-20___z7O3Z`,
	"fontS22": `AutoCompleteOption-module__font-s-22___Q1LoV`,
	"fontS28": `AutoCompleteOption-module__font-s-28___Eda5n`,
	"fontW400": `AutoCompleteOption-module__font-w-400___wZS2H`,
	"fontW500": `AutoCompleteOption-module__font-w-500___ril8k`,
	"fontW600": `AutoCompleteOption-module__font-w-600___q_1mP`,
	"fontW700": `AutoCompleteOption-module__font-w-700____0SEJ`,
	"p5": `AutoCompleteOption-module__p-5___sOso3`,
	"p12": `AutoCompleteOption-module__p-12___lAWfM`,
	"p16": `AutoCompleteOption-module__p-16___SZTRk`,
	"p30": `AutoCompleteOption-module__p-30___YL7V1`,
	"pB0": `AutoCompleteOption-module__p-b-0___XX6yo`,
	"pB5": `AutoCompleteOption-module__p-b-5___P8VpM`,
	"pB10": `AutoCompleteOption-module__p-b-10___AkD0u`,
	"pB12": `AutoCompleteOption-module__p-b-12___zZ4_3`,
	"pB16": `AutoCompleteOption-module__p-b-16___IFV5G`,
	"pB18": `AutoCompleteOption-module__p-b-18___csUjQ`,
	"pB20": `AutoCompleteOption-module__p-b-20___LAfWC`,
	"pB25": `AutoCompleteOption-module__p-b-25___ktu1I`,
	"pB30": `AutoCompleteOption-module__p-b-30___aHDz7`,
	"pB50": `AutoCompleteOption-module__p-b-50___l5ixM`,
	"pT0": `AutoCompleteOption-module__p-t-0___uOkhl`,
	"pT12": `AutoCompleteOption-module__p-t-12___VP8Qr`,
	"pT16": `AutoCompleteOption-module__p-t-16___wzMDE`,
	"pT18": `AutoCompleteOption-module__p-t-18___iYWp8`,
	"pT20": `AutoCompleteOption-module__p-t-20___W8vUh`,
	"pT30": `AutoCompleteOption-module__p-t-30___FV3bT`,
	"pT40": `AutoCompleteOption-module__p-t-40___haaUR`,
	"pT50": `AutoCompleteOption-module__p-t-50___A5LlW`,
	"pL20": `AutoCompleteOption-module__p-l-20___CRART`,
	"pL30": `AutoCompleteOption-module__p-l-30___d4ODy`,
	"pL40": `AutoCompleteOption-module__p-l-40___NDuEC`,
	"pR16": `AutoCompleteOption-module__p-r-16___ye03R`,
	"pR20": `AutoCompleteOption-module__p-r-20___X26b4`,
	"pR30": `AutoCompleteOption-module__p-r-30___sB8CQ`,
	"pR50": `AutoCompleteOption-module__p-r-50___oqWHZ`,
	"pR60": `AutoCompleteOption-module__p-r-60___eAR_S`,
	"mB1": `AutoCompleteOption-module__m-b-1___VIxoa`,
	"mB2": `AutoCompleteOption-module__m-b-2___IFspY`,
	"mB6": `AutoCompleteOption-module__m-b-6___dT4lG`,
	"mB8": `AutoCompleteOption-module__m-b-8___QAV0o`,
	"mB10": `AutoCompleteOption-module__m-b-10___FB1HR`,
	"mB14": `AutoCompleteOption-module__m-b-14___pxuNh`,
	"mB16": `AutoCompleteOption-module__m-b-16___SN4aJ`,
	"mB20": `AutoCompleteOption-module__m-b-20___HYHwd`,
	"mB22": `AutoCompleteOption-module__m-b-22___I6Z9t`,
	"mB24": `AutoCompleteOption-module__m-b-24___qA2H9`,
	"mB30": `AutoCompleteOption-module__m-b-30___qRDjJ`,
	"mB32": `AutoCompleteOption-module__m-b-32___QzSm7`,
	"mB40": `AutoCompleteOption-module__m-b-40___m1gs3`,
	"mT2": `AutoCompleteOption-module__m-t-2___tICZY`,
	"mT3": `AutoCompleteOption-module__m-t-3___LhHwb`,
	"mT4": `AutoCompleteOption-module__m-t-4___M1SEi`,
	"mT5": `AutoCompleteOption-module__m-t-5___YzWVQ`,
	"mT8": `AutoCompleteOption-module__m-t-8___rNTwQ`,
	"mT10": `AutoCompleteOption-module__m-t-10___Vhnfa`,
	"mT15": `AutoCompleteOption-module__m-t-15___Ic5MG`,
	"mT16": `AutoCompleteOption-module__m-t-16___L9Mda`,
	"mT20": `AutoCompleteOption-module__m-t-20___V4RC1`,
	"mT22": `AutoCompleteOption-module__m-t-22___mcLcq`,
	"mT30": `AutoCompleteOption-module__m-t-30____OK59`,
	"mT32": `AutoCompleteOption-module__m-t-32___aX9Re`,
	"mLAuto": `AutoCompleteOption-module__m-l-auto___YF39L`,
	"mL4": `AutoCompleteOption-module__m-l-4___r684F`,
	"mL5": `AutoCompleteOption-module__m-l-5___mtxcq`,
	"mL6": `AutoCompleteOption-module__m-l-6___TP9jG`,
	"mL8": `AutoCompleteOption-module__m-l-8___ns6vh`,
	"mL10": `AutoCompleteOption-module__m-l-10___OZ0hf`,
	"mL16": `AutoCompleteOption-module__m-l-16___nPSBK`,
	"mL20": `AutoCompleteOption-module__m-l-20___iKGls`,
	"mL24": `AutoCompleteOption-module__m-l-24___PW7bv`,
	"mL30": `AutoCompleteOption-module__m-l-30___tSiMF`,
	"mL35": `AutoCompleteOption-module__m-l-35___nrDGn`,
	"mL40": `AutoCompleteOption-module__m-l-40___llfGT`,
	"mR8": `AutoCompleteOption-module__m-r-8___J5odo`,
	"mR10": `AutoCompleteOption-module__m-r-10____IK49`,
	"mR16": `AutoCompleteOption-module__m-r-16___DIVnt`,
	"mR20": `AutoCompleteOption-module__m-r-20___lM8Sz`,
	"mR24": `AutoCompleteOption-module__m-r-24___JI7eo`,
	"mR30": `AutoCompleteOption-module__m-r-30___gPCJ9`,
	"mR40": `AutoCompleteOption-module__m-r-40___elQhU`,
	"borderR3": `AutoCompleteOption-module__border-r-3___g1G_w`,
	"borderR4": `AutoCompleteOption-module__border-r-4___jAdnT`,
	"borderR6": `AutoCompleteOption-module__border-r-6___VuNoF`,
	"borderR10": `AutoCompleteOption-module__border-r-10___WcRzG`,
	"borderR12": `AutoCompleteOption-module__border-r-12___ihyLb`,
	"borderR16": `AutoCompleteOption-module__border-r-16___O8BfV`,
	"borderR50": `AutoCompleteOption-module__border-r-50___HAKY8`,
	"primaryBorder": `AutoCompleteOption-module__primary-border___dEUxj`,
	"primaryBorderB": `AutoCompleteOption-module__primary-border-b___sR7VI`,
	"primaryBorderT": `AutoCompleteOption-module__primary-border-t___oNXlD`,
	"primaryBorderL": `AutoCompleteOption-module__primary-border-l___N5Mra`,
	"primaryBorderR": `AutoCompleteOption-module__primary-border-r___QHMXV`,
	"secondaryBorder": `AutoCompleteOption-module__secondary-border___T86id`,
	"secondaryBorderB": `AutoCompleteOption-module__secondary-border-b___UtAzR`,
	"secondaryBorderT": `AutoCompleteOption-module__secondary-border-t___vh9jF`,
	"secondaryBorderL": `AutoCompleteOption-module__secondary-border-l___rAThQ`,
	"secondaryBorderR": `AutoCompleteOption-module__secondary-border-r___wZOMo`,
	"gap0": `AutoCompleteOption-module__gap-0___qgHE4`,
	"gap2": `AutoCompleteOption-module__gap-2___pds6f`,
	"gap4": `AutoCompleteOption-module__gap-4___nQrY3`,
	"gap5": `AutoCompleteOption-module__gap-5___ZVImR`,
	"gap6": `AutoCompleteOption-module__gap-6___hCzuL`,
	"gap8": `AutoCompleteOption-module__gap-8___jLpD1`,
	"gap10": `AutoCompleteOption-module__gap-10___as_Qg`,
	"gap12": `AutoCompleteOption-module__gap-12___nnNbr`,
	"gap14": `AutoCompleteOption-module__gap-14___ucwWC`,
	"gap16": `AutoCompleteOption-module__gap-16___qSflx`,
	"gap18": `AutoCompleteOption-module__gap-18___SILU2`,
	"gap20": `AutoCompleteOption-module__gap-20___uOU63`,
	"gap24": `AutoCompleteOption-module__gap-24___Hcs9I`,
	"gap26": `AutoCompleteOption-module__gap-26___kzPtQ`,
	"gap30": `AutoCompleteOption-module__gap-30___dwsNT`,
	"gap32": `AutoCompleteOption-module__gap-32___GJyro`,
	"gap40": `AutoCompleteOption-module__gap-40___h09Db`,
	"gap50": `AutoCompleteOption-module__gap-50___J0ayA`,
	"flex1": `AutoCompleteOption-module__flex-1___VnIM9`,
	"flexNone": `AutoCompleteOption-module__flex-none___bHJBw`,
	"flexColumn": `AutoCompleteOption-module__flex-column___JGMTW`,
	"flexRow": `AutoCompleteOption-module__flex-row___aRIP6`,
	"verticallyCentered": `AutoCompleteOption-module__vertically-centered___b0qti`,
	"horizontallyCentered": `AutoCompleteOption-module__horizontally-centered___pXlqM`,
	"horizontallyEnd": `AutoCompleteOption-module__horizontally-end___WNW_i`,
	"verticallyStart": `AutoCompleteOption-module__vertically-start___DWjya`,
	"spaceBetween": `AutoCompleteOption-module__space-between___Wht9k`,
	"flexWrap": `AutoCompleteOption-module__flex-wrap___foSL6`,
	"height100": `AutoCompleteOption-module__height-100___t18Ip`,
	"width50": `AutoCompleteOption-module__width-50___e5VnW`,
	"width100": `AutoCompleteOption-module__width-100___MlRoM`,
	"cursorPointer": `AutoCompleteOption-module__cursor-pointer___iiBzd`,
	"cursorNotAllowed": `AutoCompleteOption-module__cursor-not-allowed___jFclO`,
	"absoluteCentered": `AutoCompleteOption-module__absolute-centered___plCzM`,
	"absolute": `AutoCompleteOption-module__absolute___gF_tU`,
	"relative": `AutoCompleteOption-module__relative___qN0H5`,
	"fixed": `AutoCompleteOption-module__fixed___ENxEW`,
	"visible": `AutoCompleteOption-module__visible___AtoeT`,
	"invisible": `AutoCompleteOption-module__invisible___Q_1Vx`,
	"col90": `AutoCompleteOption-module__col-90___sQopt`,
	"colAuto": `AutoCompleteOption-module__col-auto___mf3Gz`,
	"medicalTabs": `AutoCompleteOption-module__medical-tabs___zFd38`,
	"medicalTableNew": `AutoCompleteOption-module__medical-table-new___H1B4H`,
	"noPagination": `AutoCompleteOption-module__no-pagination___cc_TA`,
	"medicalTableEmpty": `AutoCompleteOption-module__medical-table-empty___dHQU8`,
	"iconBtn": `AutoCompleteOption-module__icon-btn___tRxAx`,
	"searchIcon": `AutoCompleteOption-module__search-icon___AOOBK`,
	"disableSelect": `AutoCompleteOption-module__disable-select___vmaGw`,
	"breakWord": `AutoCompleteOption-module__break-word___TjarC`,
	"popupClearBtn": `AutoCompleteOption-module__popup-clear-btn___rrd_8`,
	"scrollMB20": `AutoCompleteOption-module__scroll-m-b-20___sU9sX`,
	"name": `AutoCompleteOption-module__name___CdDAD`,
	"info": `AutoCompleteOption-module__info___S03W8`
};
module.exports = ___CSS_LOADER_EXPORT___;
